import { useCallback, useRef } from "react"

/**
 * Retourne une fonction qui joue le son `src`.
 * L'élément audio n'est créé qu'au premier appel (le navigateur n'autorise de toute façon
 * la lecture qu'après une interaction de l'utilisateur), puis réutilisé.
 */
export const useSoundEffect = (src: string) => {
  const audioRef = useRef<HTMLAudioElement | null>(null)

  return useCallback(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio(src)
    }
    const audio = audioRef.current
    // Rejoue depuis le début même si le son précédent n'est pas terminé
    audio.currentTime = 0
    // Lecture bloquée par le navigateur ou son indisponible : le jeu reste utilisable sans le son
    audio.play()?.catch(() => undefined)
  }, [src])
}
